export var GROSS_TYPES = {
  FRONT: 'FRONT',
  BACK: 'BACK'
};
export var YES = __('Yes');
export var NO = __('No');
var FILTER_IDS = {
  DEAL_CONFIRMED: 'dealConfirmed'
};
export var YES_OR_NO_OPTIONS = [{
  value: true,
  label: YES
}, {
  value: false,
  label: NO
}];
export var DEAL_CONFIRMED_FILTER = {
  id: FILTER_IDS.DEAL_CONFIRMED,
  name: __('Deal Confirmed'),
  type: 'SINGLE_SELECT',
  additional: {
    options: YES_OR_NO_OPTIONS
  }
};